import { lazy } from 'react';

import { toast } from 'pixel-react';
import type { RouteObject } from 'react-router-dom';

const RoleDetails = lazy(
  () =>
    import('@/pages/Configuration/userManagement/component/drawer/details/roleDetails/rolesDetails'),
);
const ProjectManagementDetails = lazy(
  () =>
    import('@/pages/Configuration/userManagement/component/drawer/details/userDetails/projectManagementDrawer'),
);
const UserImpactListDrawer = lazy(
  () =>
    import('@/pages/Configuration/userManagement/component/drawer/impactList/UserImpactListDrawer'),
);
const GroupDeleteModal = lazy(
  () =>
    import('@/pages/Configuration/userManagement/component/drawer/modal/DeleteModal/groupsDeleteModal/groupDeleteModal'),
);
const RoleDeleteModal = lazy(
  () =>
    import('@/pages/Configuration/userManagement/component/drawer/modal/DeleteModal/rolesDelete/rolesDelete'),
);
const UserDeleteModal = lazy(
  () =>
    import('@/pages/Configuration/userManagement/component/drawer/modal/DeleteModal/userDeleteModal/userDeleteModal'),
);
const CreateEditRole = lazy(
  () =>
    import('@/pages/Configuration/userManagement/rolesLandingPage/createEditRole'),
);
const UserManagementLandingPage = lazy(
  () =>
    import('@/pages/Configuration/userManagement/UserManagementLandingPage'),
);
const AddUserToIndividualProject = lazy(
  () =>
    import('@/pages/Configuration/userManagement/usersLandingPage/addUserToIndividualProject'),
);
const AddUserToProject = lazy(
  () =>
    import('@/pages/Configuration/userManagement/usersLandingPage/addUserToProject'),
);

const CreateEditGroup = lazy(() => import('suites/CreateEditEmailGroup'));

export const UsersManagementRoutes: RouteObject[] = [
  {
    path: '/configuration/user-management/*',
    element: <UserManagementLandingPage />,
    children: [
      {
        path: ':activeTab/details/:userId',
        element: <ProjectManagementDetails />,
      },
      {
        path: 'roles/roles-details/:roleId',
        element: <RoleDetails />,
      },
      {
        path: 'users/delete-modal/:userName/:userId',
        element: <UserDeleteModal />,
      },
      {
        path: 'roles/delete-modal/:userName/:userId',
        element: <RoleDeleteModal />,
      },
      {
        path: 'groups/delete-modal/:groupId/:groupName',
        element: <GroupDeleteModal />,
      },

      {
        path: 'roles/create-drawer',
        element: <CreateEditRole mode={'create'} />,
      },
      {
        path: 'groups/create-drawer',
        element: (
          <CreateEditGroup
            mode={'create'}
            toast={toast}
            isBackButtonVisible={false}
          />
        ),
      },

      {
        path: 'roles/edit-drawer/:userId',
        element: <CreateEditRole mode={'edit'} />,
      },
      {
        path: 'groups/edit-drawer/:groupId',
        element: (
          <CreateEditGroup
            mode={'edit'}
            toast={toast}
            isBackButtonVisible={false}
          />
        ),
      },
      {
        path: 'users/add-user/:userId/:userName',
        element: <AddUserToProject />,
      },
      {
        path: ':activeTabId/impact-list-drawer/:value/:userName/:userId',
        element: <UserImpactListDrawer />,
      },

      {
        path: 'users/add-user',
        element: <AddUserToIndividualProject />,
      },
      {
        path: 'users/edit-user',
        element: <AddUserToIndividualProject />,
      },
    ],
  },
];
